export const userAccess = (moduleName, component) => {
    if (localStorage.getItem("modules") == "" && localStorage.getItem("authType") == "ADMIN") {
        return true
    } else {
        let permittedAccess = localStorage.getItem("modules") ? JSON.parse(localStorage.getItem("modules")) : []

        return permittedAccess.includes(moduleName) ? true : false
    }
}